import type { RouterConfig } from '@nuxt/schema';
import useBrand from './utils/useBrand';

const { isMcom } = useBrand();

export default <RouterConfig>{
  routes: (_routes) =>
    isMcom
      ? [
          {
            name: 'wallet',
            path: '/account/wallet',

            component: () => import('./pages/walletPage.vue'),
          },
          {
            name: 'promotionoffers',
            path: '/shop/coupons-deals',
            component: () => import('./view/PromotionOffers.vue'),
          },
          {
            name: 'printPromotionalGiftCard',
            path: '/account/printPromotionalGiftCard',
            component: () => import('./pages/MacysMoneyPrintPage.vue'),
          },
        ]
      : [
          {
            name: 'wallet',
            path: '/account/wallet',

            component: () => import('./pages/walletBPage.vue'),
          },
          {
            name: 'promotionoffers',
            path: '/shop/coupons-sales-promotions',
            component: () => import('./view/PromotionOffers.vue'),
          },
          {
            name: 'printReward',
            path: '/account/printreward',
            component: () => import('./pages/BRecaptchaRewardsPage.vue'),
          },
        ],
};
